/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Title_AccentInputs */

const en_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`directly.`)
};

const es_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`con Mark.`)
};

const de_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direkt.`)
};

const zh_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ar_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباشرة.`)
};

const fr_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`directement.`)
};

const vi_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`với Mark.`)
};

const sw_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moja kwa moja.`)
};

const th_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const bs_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direktno.`)
};

const ja_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연락하세요.`)
};

const pt_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`com o Mark.`)
};

const it_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direttamente.`)
};

const sv_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direkt.`)
};

const nl_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`met Mark.`)
};

const da_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direkte.`)
};

const nb_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direkte.`)
};

const fi_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suoraan Markiin.`)
};

const pl_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bezpośrednio z Markiem.`)
};

const ru_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`напрямую.`)
};

const tr_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`doğrudan ulaşın.`)
};

const hi_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपर्क करें।`)
};

const id_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`langsung.`)
};

const ms_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`secara terus.`)
};

const cs_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`přímo.`)
};

const el_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`με τον Mark.`)
};

const he_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ישירות.`)
};

const af_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`direk.`)
};

const hu_contact_title_accent = /** @type {(inputs: Contact_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`közvetlenül Markkal.`)
};

/**
* | output |
* | --- |
* | "directly." |
*
* @param {Contact_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_title_accent = /** @type {((inputs?: Contact_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_title_accent(inputs)
	if (locale === "de") return de_contact_title_accent(inputs)
	if (locale === "zh") return zh_contact_title_accent(inputs)
	if (locale === "ar") return ar_contact_title_accent(inputs)
	if (locale === "fr") return fr_contact_title_accent(inputs)
	if (locale === "vi") return vi_contact_title_accent(inputs)
	if (locale === "sw") return sw_contact_title_accent(inputs)
	if (locale === "th") return th_contact_title_accent(inputs)
	if (locale === "bs") return bs_contact_title_accent(inputs)
	if (locale === "ja") return ja_contact_title_accent(inputs)
	if (locale === "ko") return ko_contact_title_accent(inputs)
	if (locale === "pt") return pt_contact_title_accent(inputs)
	if (locale === "it") return it_contact_title_accent(inputs)
	if (locale === "sv") return sv_contact_title_accent(inputs)
	if (locale === "nl") return nl_contact_title_accent(inputs)
	if (locale === "da") return da_contact_title_accent(inputs)
	if (locale === "nb") return nb_contact_title_accent(inputs)
	if (locale === "fi") return fi_contact_title_accent(inputs)
	if (locale === "pl") return pl_contact_title_accent(inputs)
	if (locale === "ru") return ru_contact_title_accent(inputs)
	if (locale === "tr") return tr_contact_title_accent(inputs)
	if (locale === "hi") return hi_contact_title_accent(inputs)
	if (locale === "id") return id_contact_title_accent(inputs)
	if (locale === "ms") return ms_contact_title_accent(inputs)
	if (locale === "cs") return cs_contact_title_accent(inputs)
	if (locale === "el") return el_contact_title_accent(inputs)
	if (locale === "he") return he_contact_title_accent(inputs)
	if (locale === "af") return af_contact_title_accent(inputs)
	if (locale === "hu") return hu_contact_title_accent(inputs)
	return en_contact_title_accent(inputs)
});